import { SVGProps } from "react";

const BuildingV2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={63}
    height={63}
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M32.8131 57.7504H10.7106C7.66562 57.7504 5.17188 55.3092 5.17188 52.3167V13.3617C5.17188 6.48418 10.2906 3.36043 16.5644 6.43168L28.2194 12.1542C30.7394 13.3879 32.8131 16.6692 32.8131 19.4517V57.7504Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.6712 39.5325V49.455C57.6712 55.125 55.0462 57.75 49.3762 57.75H32.8125V27.3525L34.0463 27.615L45.8587 30.2663L51.1875 31.4475C54.6525 32.2088 57.4875 33.9938 57.645 39.0338C57.6712 39.1913 57.6712 39.3488 57.6712 39.5325Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4375 23.6255H23.5463"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4375 34.1255H23.5463"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.8594 30.2665V38.719C45.8594 41.974 43.2081 44.6252 39.9531 44.6252C36.6981 44.6252 34.0469 41.974 34.0469 38.719V27.6152L45.8594 30.2665Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.6456 39.0341C57.4881 42.1316 54.9156 44.6254 51.7656 44.6254C48.5106 44.6254 45.8594 41.9741 45.8594 38.7191V30.2666L51.1881 31.4479C54.6531 32.2091 57.4881 33.9941 57.6456 39.0341Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default BuildingV2;
